import { ReviewGetType, ReviewInterface } from "@swivl-mono/types";
import React, { useEffect, useState } from "react";

import { Member } from "../../../Models/Member/Member.Current";
import { fetchReviews } from "./ReviewCharts";

const ViewAllReviews: React.FC = () => {
  const [reviews, setReviews] = useState<ReviewInterface[]>([]);

  useEffect(() => {
    fetchReviews(Member.orgId!, ReviewGetType.ALL).then((data) => {
      setReviews(data);
    });
  }, []);

  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>Review Date</th>
            <th>Reviewer Name</th>
            <th>Review Rating</th>
            <th>Review Text</th>
            <th>Location ID</th>
            <th>Has Reply?</th>
          </tr>
        </thead>
        <tbody>
          {reviews.map((review) => (
            <tr key={review.id}>
              <td>{new Date(review.reviewDate).toLocaleDateString()}</td>
              <td>{review.reviewerName}</td>
              <td>{review.rating}</td>
              <td>{review.text}</td>
              <td>{review.locationId}</td>
              <td>{review.hasReply}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ViewAllReviews;
